"use client";
import { useEffect, useState } from "react";

// check xem component khi mount đang là dark hay light
export function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
}
